import Table from 'src/legacy/components/AgGrid/Table';

export * from './HeaderRender';
export * from './Renderer';
export * from './TableResultCount';
export * from './Table';
export default Table;
